import React, { FunctionComponent } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { Navbar } from 'components/Navbar';
import SubNavBar from 'components/SubNavBar';
import { IUser } from 'interfaces/IUser';
import locations, { routes } from 'routes';

import styles from './PrivateRoute.module.scss';
import { shouldHideSubNavByPath } from './utils';

interface Props {
  [routeProp: string]: any;
  user: IUser;
  component: FunctionComponent;
}

const PrivateRoute: React.FC<Props> = ({
  component: Component,
  user,
  ...rest
}) => {
  const location = useLocation();
  const isRootLocation = location.pathname === routes.rootPath;
  const isProfileIncomplete =
    !user.isProfileCompleted || !user.preferences?.termsAndConditionsAccepted;
  const displaySubNavBar = !shouldHideSubNavByPath(location.pathname);

  const routeComponent = () => {
    if (!user?.id) {
      return (
        <Redirect
          to={{ pathname: locations.loginEmail(), state: { from: location } }}
        />
      );
    }

    const isWizardPage = location.pathname === locations.welcomeWizard();

    if (isProfileIncomplete && !isWizardPage) {
      return <Redirect to={{ pathname: locations.welcomeWizard() }} />;
    }

    return (
      <div
        className={classNames({
          [styles['with-navbar']]: !isWizardPage,
          [styles['with-subnavbar']]: displaySubNavBar,
        })}
      >
        {!isWizardPage && (
          <>
            <Navbar isSearchVisible={!isRootLocation} user={user} />
            {displaySubNavBar && <SubNavBar />}
          </>
        )}
        <Component {...rest} />
      </div>
    );
  };

  return <Route {...rest} render={routeComponent} />;
};

export default PrivateRoute;
